import React, { useEffect, useState } from 'react';

import Footer from '../../Components/Footer';
import { Formik, Form, yupToFormErrors } from 'formik';
import { Checkbox, CircularProgress, Divider, List, ListItem, ListItemIcon, ListItemText, Snackbar, Step, StepButton, StepIcon, StepLabel, Stepper, TextField as Upload } from '@material-ui/core';
import * as Yup from 'yup';
import { makeStyles } from '@material-ui/core/styles';
import {
  Container,
  Grid,
  Typography
} from '@material-ui/core';
import Textfield from '../../Components/FormsUI/Textfield';
import Viewfield from '../../Components/FormsUI/Viewfield';
import SelectDistrict from '../../Components/FormsUI/SelectDistrict';
// import { DatePicker } from "@progress/kendo-react-dateinputs";
import Select from '../../Components/FormsUI/Select';
import DatePicker from '../../Components/FormsUI/DataTimePicker';
import { fatheroccupationdata, motheroccupationdata, autismData, bloodData, genederData, quotaData2, religionData, examNameData, gradeData, boardData, examGroupData, medium, yesNo } from '../../data/data';
import { Link, useHistory } from "react-router-dom";

import useReactRouter from 'use-react-router';
import { Button as Submit } from '@material-ui/core';
import { Button as Buttonh } from '@material-ui/core';
import { green, purple } from "@material-ui/core/colors";
import { TextField as TextF, MenuItem } from '@material-ui/core';
import HeaderMenu from '../../Components/Header/headeradmission';
// import AdmissionMenu from '../../Components/Header/shortadmissionmenu';

import AdmissionMenu from '../../Components/Header/shortadmissionmenuItn';





const useStyles = makeStyles((theme) => ({
  formWrapper: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(8),
  },
  root: {
    color: green[900],
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "rgba(0, 0, 0, 0.23)" // default
      },
      "&.Mui-focused fieldset": {
        border: "1px solid #C4C4C4" // customized
      }
    }
  }
}));





let otherInfo = JSON.parse(localStorage.getItem('otherInfo')) || {};
const ShortAdmissionFormItn = () => {
  const { match } = useReactRouter();
  const [instInfo, setinstInfo] = useState({});
  const [classData, setClassData] = useState([]);
  const [classDataId, setClassDataID] = useState(undefined);
  const [groupData, setgroupData] = useState([]);
  const [groupDataId, setgroupDataID] = useState(undefined);


  useEffect(() => {
    const fetchData = async () => {
      let res = await fetch(`${process.env.REACT_APP_API_ROOT}/public/online-applicantion/institute-info/${match.params.id}`)
      let data = await res.json()
      setinstInfo(data?.item)
      let classres = await fetch(`${process.env.REACT_APP_API_ROOT}/public/online/admission/class/list?instituteId=${match.params.id}`)
      let classdata = await classres.json()
      setClassData(classdata?.item)
    }
    fetchData();
  }, []);

  async function handleClassData(evt) {
    setClassDataID(evt.target.value)
    setgroupDataID(undefined);
    let groupres = await fetch(`${process.env.REACT_APP_API_ROOT}/public/online/admission/group/configuration/list/by/class-id?classId=${evt.target.value}&instituteId=${match.params.id}`)
    let groupdata = await groupres.json()
    setgroupData(groupdata?.item)
  }

  async function handleGroupData(evt) {
    setgroupDataID(evt.target.value)
    otherInfo = groupData?.find(item => item.id == evt.target.value)
  }

  const [info, setInfo] = useState({});

  useEffect(() => {
    let infox = JSON.parse(localStorage.getItem('studentinfo'))
    if (infox === null) {
      setInfo({})
    } else {
      setInfo(infox)
    }
  }, [])



  const history = useHistory();

  if (info === null) {
    history.push("/");
  }

  const INITIAL_FORM_STATE = {
    studentName: info?.studentName,
    fatherName: info?.fatherName,
    motherName: info?.motherName,

    // medium: info?.medium,
    fatherWorkPlace: info?.fatherWorkPlace,
    motherWorkPlace: info?.motherWorkPlace,
    fatherEducation: info?.fatherEducation,
    fatherDesignation: info?.fatherDesignation,
    motherEducation: info?.motherEducation,
    motherDesignation: info?.motherDesignation,


    localGuardianMobile: info?.localGuardianMobile,
    localGuardianEmail: info?.localGuardianEmail,
    dateOfBirth: info?.studentDOB,
    religion: info?.studentReligion,
    gender: info?.studentGender,
    lastInstituteName: info?.lastInstituteName,
    mobileNumber: info?.mobileNumber,
    bloodGroup: info?.bloodGroup,
    quota: '',
    birthcertificateNo: '',
    nationality: '',
    autism: '',
    fatherMobile: '',
    fatherOccupation: '',
    fatherIncome: '',
    fatherNid: '',

    motherMobile: '',
    motherNid: '',
    motherOccupation: '',
    motherIncome: '',
    roll:'',
    presentAddress: '',
    permanentAddress: '',
    permanentThanaId: '',
    localGuardianName: '',
    presentDistrict: '',
    presentThanaId: '',
     lastDegree: '',
    permanentDistrict: '',
  };



  const FORM_VALIDATION = Yup.object().shape({
    studentName: Yup.string()
      .required('Required'),

  });



  const classes = useStyles();

  const [payId, setpayId] = useState();
  const [successPay, setsuccessPay] = useState(false);
  const [step, setStep] = useState(1);
  const [sameAs, setSameAs] = useState(false);

  const [districtList, setdistrictList] = useState([]);
  const [thanaList, setPresentthanaList] = useState([]);
  const [permanentThanaList, setPermanentThanaList] = useState([]);
  const [presentThanaId, setPresentThanaId] = useState('');
  const [permanentThanaId, setPermanentThanaId] = useState('');
  const [presentDisId, setPresentDisId] = useState('');
  const [permanentDisId, setPermanentDISId] = useState('');

  const [imageFileContent, setimageFileContent] = useState();
  const [imageFileSave, setimageFileSave] = useState('');
  const [imageFileName, setimageFileName] = useState(undefined);

    const [imageFileContentFather, setimageFileContentFather] = useState();
  const [imageFileSaveFather, setimageFileSaveFather] = useState('');
  const [imageFileNameFather, setimageFileNameFather] = useState(undefined);

  

  function clearFileInput(ctrl) {
    try {
      ctrl.value = null;
    } catch (ex) { }
    if (ctrl.value) {
      ctrl.parentNode.replaceChild(ctrl.cloneNode(true), ctrl);
    }
  }
  const imageUpload = (e) => {
    e.preventDefault();
    const reader = new FileReader();
    const file = e.target.files[0];
    if (file?.size > 600000) {
      // file.target.value = null;
      clearFileInput(document.getElementById("imgfile"));
      setimageFileSave(false);
      setimageFileContent('');
      setimageFileName(undefined);
      alert("Image size should be less than 600KB");
      return;
    };
    if (reader !== undefined && file !== undefined) {
      setimageFileSave(true);

      reader.onloadend = () => {
        setimageFileName(file.name)
        setimageFileContent(reader.result.split(',')[1])
      }
      reader.readAsDataURL(file);
    }
  };

    const imageUploadFather = (e) => {
    e.preventDefault();
    const reader = new FileReader();
    const file = e.target.files[0];
    if (file?.size > 600000) {
      // file.target.value = null;
      clearFileInput(document.getElementById("imgfileFather"));
      setimageFileSaveFather(false);
      setimageFileContentFather('');
      setimageFileNameFather(undefined);
      alert("Image size should be less than 600KB");
      return;
    };
    if (reader !== undefined && file !== undefined) {
      setimageFileSaveFather(true);
      reader.onloadend = () => {
        setimageFileNameFather(file.name)
        setimageFileContentFather(reader.result.split(',')[1])
      }
      reader.readAsDataURL(file);
    }
  };


  const validateOthers = () => {
    // console.log('sss')
  }


  async function paymentPage() {
    try {
      const rawResponse = await fetch(`${process.env.REACT_APP_API_ROOT}/public/get/online-admission-fees-payment/spg/session-id?registrationId=${payId}&instituteId=${parseInt(match.params.id)}`, {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        // body: JSON.stringify(submit)
      });
      if (rawResponse.status === 201 || rawResponse.status === 200) {
        const content = await rawResponse.json();
        if (content?.messageType === 1) {
          //window.open('https://api.shebashikkha.com/public/goto/spg-online-admission-payment/portal?sessiontoken=' + content?.item);
            console.log(content?.item)
            window.open(content?.item);
        } else {
          alert(content?.message);
        }

      } else {
        alert("Something went wrong");

      }

    }
    catch (err) {
      // not jumping in here.
      console.log(err)
    }

  }


  async function nextData(values) {

    let postData = {
      "studentImageFileContent": imageFileContent === undefined ? "R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==" : imageFileContent,
      "studentImageName": imageFileName === undefined ? "no_image.png" : imageFileName,
      "studentImageFileSave": true,
  
      "fatherImageFileContent": imageFileContentFather === undefined ? "R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==" : imageFileContentFather,
      "fatherImageName": imageFileNameFather === undefined ? "no_image.png" : imageFileNameFather,
      "fatherImageFileSave": true,

      "academicYear": 2023,

      "applicantName": values.studentName,
      "roll": values.roll,

      
      "birthcertificateNo": values.birthcertificateNo,
      "dateOfBirth": values.dateOfBirth,
      "gender": values.gender,
      "religion": values.religion,
      "bloodGroup": values.bloodGroup,
      "nationality": values.nationality,
      "localGuardianMobile": values.localGuardianMobile,
      "fatherName": values.fatherName,

      "fatherNid": values.fatherNid,
      "fatherOccupation": values.fatherOccupation,
      "motherName": values.motherName,
      "quota": values.quota,

      "motherNid": values.motherNid,
      "motherOccupation": values.motherOccupation,

      "presentAddress": values.presentAddress,
      "localGuardianName": values.localGuardianName,
      "localGuardianMobile": values.localGuardianMobile,
      "localGuardianEmail": values.localGuardianEmail,
      "lastInstituteName": values.lastInstituteName,
      "instituteId": match.params.id,
      "groupConfigId": otherInfo?.id,
      "admissionCharge": otherInfo?.admissionCharge,
      "serviceCharge": otherInfo?.serviceCharge,
      "fatherEducation": values.fatherEducation,
      "fatherIncome": values.fatherIncome,
      "motherMobile": values.motherMobile,
       "fatherMobile": values.fatherMobile,
      "motherEducation": values.motherEducation,
      "motherIncome": values.motherIncome,
      "presentThanaId": presentThanaId,
      "permanentAddress": values.permanentAddress,
      "permanentThanaId": permanentThanaId,


      "passportNumber": values.passportNumber,

      "dateofIssuePassport": values.dateofIssuePassport,

      "dateofExpairyPassport": values.dateofExpairyPassport,

      "designationAndOrganization": values.designationAndOrganization,

      "officeAddressAndContractNo": values.officeAddressAndContractNo,

      "currentlyEmployeed": values.currentlyEmployeed,

      "lastDegree": values.lastDegree,

      "governmentOfficial": values.governmentOfficial,

      "applicantName": values.studentName,

    }
    console.log('sssssssssssssssssssssss',postData)
    finalSubmit(postData);
  };


  const [loading, setLoading] = React.useState(false);
  async function finalSubmit(data) {
    setLoading(true);
    try {
      const rawResponse = await fetch(`${process.env.REACT_APP_API_ROOT}/public/online/admission/applicant-info/save`, {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      });
      if (rawResponse.status === 201 || rawResponse.status === 200) {
        const content = await rawResponse.json();
        // console.log(content);
        setLoading(false);
        if (content.messageType === 1) {
          setsuccessPay(true);
          setStep(4);
          setpayId(content.item)
        }
      } else {
        alert("Something went wrong");
        setLoading(false);
      }

    }
    catch (err) {
      // not jumping in here.
      console.log(err)
    }

  }



  return (
    <Grid container>
      <Grid item xs={12}>
        <HeaderMenu details={{ instituteName: instInfo?.institutename, address: instInfo?.instituteaddress, image: instInfo?.imageLink }} />
      </Grid>

      <Grid item xs={12} style={{ background: "#fff", boxShadow: "rgb(216 216 216) 0px 0px 15px 0px", padding: "15px" }}>

        <Divider />
        <AdmissionMenu />
        {!successPay && step === 1 &&
          <div className={classes.formWrapper}>

            <Formik
              initialValues={{
                ...INITIAL_FORM_STATE
              }}
              validationSchema={FORM_VALIDATION}
              onSubmit={values => {
                nextData(values);
              }}
            >

              {(formikProps) => {
                const { values, handleChange } = formikProps;
                return (
                  <Form>

                    <Grid container spacing={2}>

                      <Grid item xs={12}>
                        <Typography style={{ fontSize: "24px", textAlign: "center", marginBottom: "10px", color: "#f68b1f", fontWeight: "500" }}>
                          Student's Information
                        </Typography>
                      </Grid>
                      <Grid item xs={12} style={{ marginTop: 0 }}>
                        <Typography>
                          Course Name
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <TextF value={classDataId} required select={true} variant="outlined" fullWidth label="Class Name" onChange={(e) => {
                          handleClassData(e);
                        }} >
                          {classData.map((item, pos) => {
                            return (
                              <MenuItem key={pos} value={item.id}>
                                {item.name}
                              </MenuItem>
                            )
                          })}
                        </TextF>
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <TextF value={groupDataId} required select={true} variant="outlined" fullWidth label="Group/Trade Name" onChange={(e) => {
                          handleGroupData(e);
                        }} >
                          {groupData.map((item, pos) => {
                            return (
                              <MenuItem key={pos} value={item.id}>
                                {item.groupName}
                              </MenuItem>
                            )
                          })}
                        </TextF>
                      </Grid>
                      <Grid item xs={12} sm={2}>
                        <Viewfield
                          label="Application Fees"
                          name={otherInfo?.admissionCharge}
                        />
                      </Grid>
                      <Grid item xs={12} sm={2}>
                        <Viewfield
                          label="Service Charge"
                          name={otherInfo?.serviceCharge}
                        />
                      </Grid>
                      <Grid item xs={12} sm={2}>
                        <Viewfield
                          label="Total Charge"
                          name={(otherInfo?.totalCharge)}
                        />
                      </Grid>
                      <Grid item xs={12} style={{ marginTop: 0 }}>
                        <Typography>
                          Basic Information
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={8}>
                        <Textfield
                          name="studentName"
                          label="Name"

                        />
                      </Grid>


                       <Grid item xs={12} sm={4}>

                      <DatePicker views={['year', 'month', 'day']} 
                          name="dateOfBirth"
                          label="Date Of Birth"

                        />
                      </Grid> 

                      
                      <Grid item xs={12} sm={8}>
                        <Textfield
                          name="presentAddress"
                          label="Present Address"
                        //
                        />
                      </Grid>

                      <Grid item xs={12} sm={4}>
                        <Textfield
                          name="nationality"
                          label="Nationality"

                        />
                      </Grid>


                      <Grid item xs={12} sm={4}>
                        <Textfield
                          name="localGuardianMobile"
                          label="Phone*"

                        />
                      </Grid>

                       <Grid item xs={12} sm={4}>
                        <Textfield
                          name="localGuardianEmail"
                          label="Email*"

                        />
                      </Grid>


                      <Grid item xs={12} sm={4}>
                        <Textfield inputProps={{ maxLength: 20 }}
                          name="passportNumber"
                          label="NID/Passport Number"

                        />
                      </Grid>

                      <Grid item xs={12} sm={4}>
                        <Select
                          name="currentlyEmployeed"
                          label="Are You Currently Employeed"
                          options={yesNo}

                        />
                      </Grid>


                      
                      <Grid item xs={12} sm={4}>
                        <Select
                          name="governmentOfficial"
                          label="Are You a Government Official"
                          options={yesNo}

                        />
                      </Grid>


                      
                      <Grid item xs={12} sm={4}>
                        <Textfield
                          name="designationAndOrganization"
                          label="Designation and Organization*"

                        />
                      </Grid>


                      
                      <Grid item xs={12} sm={8}>
                        <Textfield
                          name="officeAddressAndContractNo"
                          label="Office Address and Contract No*"

                        />
                      </Grid>


                      <Grid item xs={12} sm={4}>
                        <Upload required id="imgfile" style={{ width: "100%" }} classes={{ root: classes.root }} variant="outlined" label="Your Recent Picture" focused={imageFileSave == '' && true} name="file" type="file" accept="image/*" onChange={(e) => {
                          imageUpload(e)

                        }} />
                      </Grid>


                      <Grid item xs={12} sm={12}>
                        <Textfield
                          name="lastDegree"
                          label="Latest Degree Details (Please provide details of the Degree, Institution, Result, and Year Awarded)"

                        />
                      </Grid>


                      <Grid item xs={12} style={{ marginBottom: 20 }}>
                        <Submit type="submit" style={{ float: "right", backgroundColor:"#009688" }} color='primary' variant="contained" onClick={() => validateOthers()} >
                         Submit
                        </Submit>

                      </Grid>
                    </Grid>

                  </Form>
                );
              }}
            </Formik>

          </div>
        }


        {successPay && step === 4 &&
          <>
            <p className='MuiTypography-root MuiTypography-h5' style={{ color: "Orange", marginTop: 40, textAlign: "center" }}>Applicant Info Successfully Saved.</p>
            <p className='MuiTypography-root MuiTypography-h6' style={{ marginBottom: 20, textAlign: "center" }}>Your Application ID is <strong>{payId}</strong>. You will need this Applicant ID to download Admit card After Complete your Payment</p>
            <p className='MuiTypography-root MuiTypography-h6' style={{ marginTop: 0, textAlign: "center" }}><span style={{ color: 'blue', cursor: 'pointer' }} onClick={() => window.open(
              `${process.env.REACT_APP_API_ROOT}/public/online/admission/itn-confirmation/letter/download?instituteId=${match.params.id}&registrationId=${payId}`,
              '_blank' // <- This is what makes it open in a new window.
            )}><u>Click Here</u></span> to download your form.</p>
            <p className='MuiTypography-root MuiTypography-h6' style={{ marginTop: 0, textAlign: "center" }}><span style={{ color: 'blue', cursor: 'pointer' }} onClick={() => paymentPage()} // <- This is what makes it open in a new window.
            ><u>Click Here</u></span> to make payment</p>


          </>
        }

      </Grid>
    </Grid>
  );
};

export default ShortAdmissionFormItn;
